import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { IconModule, LetModule } from '@hglobal/common';
import { TranslateService } from '@ngx-translate/core';

import { UserCardSmallComponent } from '@pp/common';
import { Account, Team } from '@pp/core/entities';
import { PpDialogService } from '@pp/core/services';
import { EditUserProfileComponent } from '@pp/edit-user-profile';

@Component({
  imports: [LetModule, IconModule, UserCardSmallComponent, TitleCasePipe],
  selector: 'pp-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserCardComponent {
  readonly #ppDialogService = inject(PpDialogService);
  readonly #translateService = inject(TranslateService);

  readonly user = input<Account>();
  readonly organization = input<Team>();
  readonly onlyAvatar = input<boolean>();

  editProfile(): void {
    this.#ppDialogService.open<EditUserProfileComponent, { user: Account; org: Team }>({
      title: this.#translateService.instant('editUser.title'),
      components: [EditUserProfileComponent],
      data: { user: this.user(), org: this.organization() },
    });
  }
}
